<template>
	<div>
		<div v-if="column.type == 'date'">
			{{item.dateTime.toDate() | moment("HH:mm D/MM/YYYY")}}
		</div>
		<div v-else>
			<div v-if="column.options">
				{{getOptionText(column, item)}}
			</div>
			<div v-else>
				<div v-if="column.preProcessor" v-html="column.preProcessor( item[column.value] )">  
				</div>
				<div v-else>
						{{ item[column.value] }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		name: "UneditableTableField", 
		props:{
			item: {type: Object}, 
			column: {type: Object }
		}, 
		methods: {
			getOptionText(column, item ){
				var value;
				if( typeof column.options[0] == 'object' ){
					if( column.otherBindingOptions ){		
						let text = column.otherBindingOptions["item-text"];
						let v = column.otherBindingOptions["item-value"];
						let answer = item[column.value];
						let answerOption = column.options.find( o => o[v] == answer );
						if( answerOption ){
							value = answerOption[text];	
						}
					}
					else {
						if( column.options.find( o => o.value == item[column.value] ) ){
							value = column.options.find( o => o.value == item[column.value] ).text;	
						}
					}
				}
				if( !value ){
					value = item[column.value]
				}
				return value;

			}
		}
	}
</script>